import styled from 'styled-components';
import { Button } from '@swordhealth/ui-corporate';

export const StyledButton = styled(Button)`
  width: ${({ $isFullWidth }) => ($isFullWidth ? '100%' : 'auto')};
`;
